import { createRequestActions } from "common/helpers/action";

export const initCpCompanyPreview = createRequestActions("CP.COMPANY.PREVIEW.INIT");
export const updateCpCompanyPreview = createRequestActions("CP.COMPANY.PREVIEW.UPDATE");
export const updateOwnerCpCompanyPreview = createRequestActions("CP.COMPANY.PREVIEW.UPDATE_OWNER");
export const removeCpCompanyPreview = createRequestActions("CP.COMPANY.PREVIEW.REMOVE");

export const searchOwnerCpCompanyPreview = createRequestActions("CP.COMPANY.PREVIEW.SEARCH_OWNER");
export const searchCompanyCpCompanyPreview = createRequestActions("CP.COMPANY.PREVIEW.SEARCH_COMPANY");
